

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MDAvatar from "components/MDAvatar";

// Ajce Hostel App React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Ajce Hostel App React example components
import TimelineItem from "layouts/dashboard/components/Timeline/TimelineItem";
import { getInOutHistory } from "framework/students/summary";
import { useEffect, useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";

import { elapsedTime } from "utils/date";

function Timeline({ inPercentage, outPercentage }) {
  const [inOutHistory, setInOutHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  async function fetch_student_data() {
    if (inOutHistory.length === 0) {
      try {
        setIsLoading(true);
        const inOutHistoryEntries = await getInOutHistory(5);
        setInOutHistory(inOutHistoryEntries);
      } catch (err) {
      } finally {
        setIsLoading(false);
      }
    }
  }
  useEffect(() => {
    fetch_student_data();
    const intervalId = setInterval(() => {
      setInOutHistory((prev) => {
        if (prev.length !== 0) return [...prev];
        return prev;
      });
    }, 1000 * 60);
    return () => clearInterval(intervalId);
  }, []);
  return (
    <Card sx={{ height: "100%", position: "relative" }}>
      <MDBox pt={3} px={3}>
        <MDTypography variant="h6" fontWeight="medium">
          Student Status
        </MDTypography>
        <MDBox mt={0} mb={2}>
          <MDTypography variant="button" color="text" fontWeight="regular">
            <MDTypography display="inline" variant="body2" verticalAlign="middle">
              <Icon color="success">arrow_upward</Icon>
            </MDTypography>
            &nbsp;
            <MDTypography variant="button" color="text" fontWeight="medium">
              {`${inPercentage}%`}
            </MDTypography>{" "}
            In
          </MDTypography>
          <MDTypography variant="button" color="text" fontWeight="regular">
            <MDTypography display="inline" variant="body2" verticalAlign="middle">
              <Icon color="error">arrow_downward</Icon>
            </MDTypography>
            &nbsp;
            <MDTypography variant="button" color="text" fontWeight="medium">
              {`${outPercentage}%`}
            </MDTypography>{" "}
            Out
          </MDTypography>
        </MDBox>
      </MDBox>
      <MDBox py={2} px={4}>
        {inOutHistory.map((inOutEntry) => (
          <TimelineItem
            key={inOutEntry.id}
            color={inOutEntry.isIn ? "success" : "error"}
            icon={<MDAvatar src={inOutEntry.imgLink} />}
            title={inOutEntry.name + (inOutEntry.isIn ? " entered" : " left")}
            description={`${inOutEntry.sem}  ${inOutEntry.branch}`}
            dateTime={elapsedTime(inOutEntry.time.toDate())}
          />
        ))}
      </MDBox>
      <Backdrop open={isLoading} sx={{ position: "absolute", borderRadius: "0.75rem" }}>
        <CircularProgress />
      </Backdrop>
    </Card>
  );
}

export default Timeline;
